module.exports = __webpack_public_path__ + "static/js/0.efab6091.chunk.worker.js"